import { CharacterData } from "../../utils/game/character/CharacterData";
import { CharacterDataUtils } from "../../utils/game/character/CharacterData";
import Cookies from "universal-cookie";
import { Dictionary } from "../../utils/sys/Dictionary";

import { getCharacterData } from "../../net/CharacterManagement";

export default class CharacterDataBank {
    private static cookies = new Cookies();

    private _characters: Dictionary<number, CharacterData> = new Dictionary();

    public constructor() {}

    /** Loads the character with the given ID into the character bank, replacing the character at the given ID if it already exists. */
    public loadCharacter(
        id: number,
        onComplete?: (characterData: CharacterData) => void,
        onError?: (error: string) => void,
    ): void {
        getCharacterData({
            id,
            token: CharacterDataBank.cookies.get("session_token"),
        }).then((data) => {
            if (data == null) {
                const message = `Failed to load character ${id}.`;
                console.error(message);
                onError?.(message);

                return;
            }

            const characterData =
                CharacterDataUtils.processRawCharacterData(data);

            this._characters.set(id, characterData);

            onComplete?.(characterData);
        });
    }

    /** Removes the character with the provided ID from the character bank. */
    public removeCharacter(id: number): boolean {
        if (this._characters.hasKey(id)) {
            this._characters.remove(id);
            return true;
        }

        return false;
    }

    public hasCharacter(id: number): boolean {
        return this._characters.hasKey(id);
    }

    public getCharacter(id: number): CharacterData | null {
        return this._characters.get(id) ?? null;
    }
}
